<template>
    <div class="ur-gnb" :style="urGnbStyle">
        <div v-if="$store.getters.contactCenterName" class="ur-gnb__logo" :class="{'ur-gnb__logo-center':logoCenter}">
            <label class="ur-gnb__title" @click="goToHome">{{title}}</label>
            <label class="ur-gnb__sub-title">{{subTitle}}</label>
        </div>
        <div v-else class="ur-gnb__logo" :class="{'ur-gnb__logo-center':logoCenter}">
            <label class="ur-gnb__title" style="cursor:auto">AICC Service</label>
        </div>
        <div v-if="$store.getters.isGnbMenuShowed" class="ur-gnb__menus" :class="{'ur-gnb__menus-center':menuCenter}">
            <ul>
                <li v-for="m in menuItems" @click="clickMenu(m)" v-bind:key="m.applicationId"
                    class="ur-gnb__menu"
                    :class="{'ur-gnb__menu--selected':checkMenu(m)}">
                    {{m.text}}
                </li>
            </ul>
        </div>
        <div v-if="$store.getters.isGnbMenuShowed" class="ur-gnb__action" >
            <div class="dropdown_wrap">
                <button class="btn_help btn_drop" @click="onClickHelpButton" v-click-outside="onClickOutside"/>
                <div class="dropdown" :style="helpStyle">
                    <ul class="dropdown_menu">
                        <!--
                        <li><a @mousedown="onClickMainMenu(menuType.faq)">FAQ</a></li>
				        <li><a @mousedown="onClickMainMenu(menuType.qna)">문의하기</a></li>
                        -->
					    <li><a @mousedown="onClickMainMenu(menuType.supportPortal)">고객지원</a></li>
					    <li><a @mousedown="onClickMainMenu(menuType.quickGuide)">퀵가이드</a></li>
					    <li><a @mousedown="onClickMainMenu(menuType.tutorial)">튜토리얼</a></li>
                        <li><a @mousedown="onClickMainMenu(menuType.userManual)">사용자 매뉴얼</a></li>
                        <!--
                        <li><a @click="onClickMainMenu(menuType.faq)">FAQ</a></li>
				        <li><a @click="onClickMainMenu(menuType.qna)">문의하기</a></li>
					    <li><a @click="onClickMainMenu(menuType.quickGuide)">퀵가이드</a></li>
					    <li><a @click="onClickMainMenu(menuType.tutorial)">튜토리얼</a></li>
                        -->
                    </ul>
                </div>
            </div>
            <div class="profile dropdown_wrap">
                <button type="button" class="initial btn_drop" @click="onClickProfileButton" v-click-outside.anchor="onClickOutside">{{initial}}</button>
                <span>{{userName}}</span>
                <div class="dropdown dropdown--profile" :style="profileStyle">
                    <ul class="dropdown_menu">
                        <li><a @mousedown="onClickMainMenu(menuType.myInfo)"><i class="my_info_icon"/>나의 정보</a></li>
				        <li><a @mousedown="onClickMainMenu(menuType.logout)"><i class="logout_icon"/>로그아웃</a></li>
					    <li><a @mousedown="onClickMainMenu(menuType.personalInfo)">개인정보 처리방침</a></li>
                        <!--
                        <li><a @click="onClickMainMenu(menuType.myInfo)">나의 정보</a></li>
				        <li><a @click="onClickMainMenu(menuType.logout)">로그아웃</a></li>
					    <li><a @click="onClickMainMenu(menuType.service)">서비스 이용약관</a></li>
					    <li><a @click="onClickMainMenu(menuType.personalInfo)">개인정보 처리방침</a></li>
                        -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'aiccGnb',
        props: {
            title: {
                type: String,
                default: 'Title'
            },
            subTitle: {
                type: String,
                default: 'Sub Title'
            },
            menuItems: {
                type: Array,
                default: () => []
            },
            menuCenter:{
                type: Boolean,
                default: false
            },
            logoCenter:{
                type: Boolean,
                default: false
            },
        },
        data(){
          return {
              menuType:{
                  faq:'faq',
                  qna:'qna',
                  supportPortal:'supportPortal',
                  quickGuide:'quickGuide',
                  tutorial:'tutorial',
                  userManual:'userManual',
                  myInfo:'myInfo',
                  logout:'logout',
                  service:'service',
                  personalInfo:'personalInfo',
              },
              outsideClick:false,
              helpDropdownShow:false,
              profileDropdownShow:false,
              selectedItem:null,
          }
        },
        mounted(){
        },
        computed:{
            helpStyle (){
                let style = {};
                if(this.helpDropdownShow === true) {
                    style['display'] = 'block';
                } else {
                    style['display'] = 'none';
                }
                return style;
            },
            profileStyle(){
                let style = {};
                if(this.profileDropdownShow === true) {
                    style['display'] = 'block';
                } else {
                    style['display'] = 'none';
                }
                return style;
            },
            urGnbStyle(){
                let style = {};
                style['absolute'] = 'absolute';
                return style;
            },
            initial(){
                let result = '';
                if(this.userName && this.userName.length > 0) {
                    result = this.userName.substr(0, 1).toUpperCase();
                }
                return result;
            },
            userName(){
                return this.$store.getters.userInfo.userName;
            },
            items() {
                 let rtn = [
                    {'value':'myInformation', 'text':'나의 정보'},
                    {'value':'logout', 'text':'로그아웃'}
                ];
                return rtn;
            },
        },
        methods: {
            goToHome(){
                this.selectedItem = null;
                utils.goHome();
                this.$store.commit('setCurrentApplication', null);
            },
            checkMenu(m) {
                return this.selectedItem == m;
            },
            clickMenu(m) {
                this.selectedItem = m;
                this.$emit('gnb-selected', m);
            },
            
            selected(v) {
                switch(v) {
                    case 'myInformation':
                        this.$emit('myInformation');
                    break;
                    case 'logout': this.$store.getters.userInfo.userId; break;
                }
            },
            onClickHelpButton(){
                console.log('help');
                if(this.helpDropdownShow === true) {
                    this.onClickOutside();
                } else {
                    this.helpDropdownShow = true;
                }
                this.profileDropdownShow = false;
            },
            onClickProfileButton(){
                console.log('profile');
                if(this.profileDropdownShow === true) {
                    this.onClickOutside();
                } else {
                    this.profileDropdownShow = true;
                }
                this.helpDropdownShow = false;
            },
            onClickMainMenu(menu){
                switch(menu) {
                    /*
                    case this.menuType.faq:
                        window.alert('FAQ로 이동 예정');
                        //window.location.href = this.$t('MSG_TXT_AICC_FAQ_URL');
                        break;
                    case this.menuType.qna:
                        window.alert('문의하기로 이동 예정');
                        break;
                    */
                    case this.menuType.supportPortal:
                        //window.location.href=this.$t('MSG_TXT_AICC_CUSTOMER_CENTER_URL');
                        window.open(this.$t('MSG_TXT_AICC_CUSTOMER_CENTER_URL'));
                        break;
                    case this.menuType.quickGuide:
                        WalkMeAPI.startFlowById(1138334);
                        break;
                    case this.menuType.tutorial:
                        WalkMeAPI.startFlowById(1138400);
                        break;
                    case this.menuType.userManual:
                        window.open(this.$t('MSG_TXT_AICC_USER_MANUAL_URL'));
                        break;
                    case this.menuType.myInfo:
                        this.$emit('onClickMyInfo');
                        break;
                    case this.menuType.logout:
                        utils.aiccMessageBox('로그아웃', '로그아웃 하시겠습니까?', '로그아웃', this.onClickLogout, '취소', null, 'small');
                        break;
                        /*
                    case this.menuType.service:
                        this.$emit('onClickServiceInfo');
                        break;
                        */
                    case this.menuType.personalInfo:
                        this.$emit('onClickPersonalInfo');
                        break;
                }
                this.onClickOutside();
            },
            onClickOutside(){
                this.helpDropdownShow = false;
                this.profileDropdownShow = false;
            },
            onClickLogout(){
                let loginType = sessionStorage.getItem("loginType");
                let queryParam = {};
                queryParam = {
                    loginType: loginType,
                };

                console.log('logintype', loginType);
                http.request('GNB', 'DTS_CMP_00044', {
                    query: queryParam,
                }).then(() => {
                }).catch(err => {
                console.error(err);
                });
            },
        }
    };
</script>
<style scoped>

    .ur-gnb {
        background: #0c1533;
        justify-content: space-between;
        height: 60px;
        z-index: 20;
        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 10%);
        border: 0px;
    }
    .ur-gnb__title {
        display: inline-block;
        color: #fff;
        font-size: 18px;
        line-height: 27px;
        font-weight: 400;
    }
    .ur-gnb__sub-title {
        font-size: 12px;
        color: #fff;
        font-weight: 300;
        line-height: 18px;
    }
    .ur-gnb__menu {
        line-height: 60px;
        font-weight: 300;
        color: rgba(255,255,255,0.6);
    }
    .ur-gnb__menu--selected {
        font-weight: 400;
        color: #fff;
    }
    .ur-gnb__menu:hover {
        font-weight: 400;
        opacity:1;
        color: #fff;
    }
    .ur-gnb__menu--selected::before {
        background-color: #fff;
        bottom: 0px;
    }

    .ur-gnb__action {
        min-width: 185px;
        margin-left: auto;
        display: flex;
    }
    .profile {
        display: inline-block;
        font-size: 0;
        height: 32px;
        position: relative;
        margin-left: 16px;
        
    }
    .profile::before {
        display: inline-block;
        content: '';
        width: 1px;
        height: 10px;
        background-color: rgba(255,255,255,0.4);
    }
    .profile span {
        display: inline-block;
        font-size: 14px;
        line-height: 21px;
        font-weight: 300;
    }
    .btn_help {
        width: 32px;
        height: 32px;
        margin-left: 16px;
        border: 0;
        background: url(../../../../assets/images/aicc/btn_help_w.png) no-repeat center;
    }
    .initial {
        display: inline-block;
        width: 30px;
        height: 30px;
        background-color: rgba(255, 255, 255, 0.6);
        line-height: 29px;
        color: #0C1533;
        text-align: center;
        border-radius: 50%;
        font-size: 16px;
        margin-right: 8px;
        margin-left: 16px;

    }
    .dropdown_wrap {
        position: relative;
        height: 32px;
    }
    .dropdown {
        display: block;
        position: absolute;
        top: 48px;
        left: 11px;
        width: 134px;
        background: #FFF;
        border: 1px solid #D0D3DE;
        border-radius: 4px;
        z-index: 2;
        box-shadow: 0 3px 6px 0 rgb(0 0 0 / 10%);
    }
    .dropdown--profile {
    }
    .dropdown:before {
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        top: -8px;
        left: 12px;
        pointer-events: none;
        border-top: none;
        border-bottom: 8px solid #D0D3DE;
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
    }
    .dropdown_menu {
        padding: 8px 0;
        word-wrap: break-word;
        word-break: keep-all;
        line-height: 16px;
        font-size: 0;
        list-style: none;
    }
    .dropdown_menu li a {
        display: flex;
        font-size: 14px;
        line-height: 24px;
        padding: 4px 12px;
        outline: 0;
        align-items: center;
        cursor: pointer;
    }
    .dropdown_menu li a i {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .my_info_icon {
        background-image: url('../../../../assets/images/aicc/ic_my_info.png');
    }
    .logout_icon {
        background-image: url('../../../../assets/images/aicc/ic_log_out.png');
    }

    /*
    .line {
        width: 1px;
        height: 10px;
        margin: 11px 0 11px 16px;
        opacity: 0.4;
        background-color: #fff;
    }
    .box {
        width: 32px;
        height: 32px;
        margin: 6px 8px 11px 9px;
        padding: 1px;
        border-radius:50%;
        background-color: #767676;
    }
    .name {
        height:21px;
        margin: 12px 32px 16px 8px;
        opacity: 0.6;
        font-family: NotoSansCJKKR;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
    }
    */
</style>